import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import { observer } from 'mobx-react'
import SelectCustom from '../../../../ContentBox/Global/Select/SelectCustom'
import FormInput from '../../../../UI/AsideModal/Form/FormInput'
import FormFieldset from '../../../../UI/AsideModal/Form/FormFieldset'

const RequiredFieldsPaidModal = observer(() => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  return (
    <FormFieldset>
      <FormField>
        <FormLabel isRequired>Заявка подписана:</FormLabel>
        <SelectCustom
          placeholder='Заявка подписана'
          valueID={modalValue.is_application_signed}
          optionLabelKey='name'
          optionValueKey='value'
          options={[
            { value: true, name: 'Да' },
            { value: false, name: 'Нет' },
          ]}
          onChange={(option) =>
            changeValues(option.value, 'is_application_signed')
          }
          isSearchable
          error={check('is_application_signed')}
          required
        />
      </FormField>

      <FormField>
        <FormLabel isRequired>{'Вид обучения'}:</FormLabel>
        <SelectCustom
          placeholder={'Вид обучения'}
          apiLinkCRM={'settings/project_settings/deal_learning_type_choices'}
          apiGetResult={(result) => result.value.choices}
          valueID={modalValue.learning_type}
          optionLabelKey='name'
          optionValueKey='name'
          onChange={(level) => changeValues(level.name, 'learning_type')}
          isSearchable
          error={check('learning_type')}
        />
      </FormField>

      <FormField>
        <FormLabel isRequired>{'Тип обучения'}:</FormLabel>
        <SelectCustom
          placeholder={'Тип обучения'}
          apiLinkCRM={'settings/project_settings/deal_education_type_choices'}
          apiGetResult={(result) => result.value.choices}
          valueID={modalValue.education_type}
          optionLabelKey='name'
          optionValueKey='name'
          onChange={(level) => changeValues(level.name, 'education_type')}
          isSearchable
          error={check('education_type')}
        />
      </FormField>

      <FormField>
        <FormLabel isRequired>{'Цель обучения'}:</FormLabel>
        <SelectCustom
          placeholder={'Цель обучения'}
          apiLinkCRM={'settings/project_settings/deal_learning_goal_choices'}
          apiGetResult={(result) => result.value.choices}
          valueID={modalValue.learning_goal}
          optionLabelKey='name'
          optionValueKey='name'
          onChange={(level) => changeValues(level.name, 'learning_goal')}
          isSearchable
          error={check('learning_goal')}
        />
      </FormField>

      <FormField>
        <FormLabel isRequired>{'Дни обучения'}:</FormLabel>
        <SelectCustom
          placeholder={'Дни обучения'}
          apiLinkCRM={'settings/project_settings/deal_learning_days_choices'}
          apiGetResult={(result) => result.value.choices}
          valueID={modalValue.learning_days}
          optionLabelKey='name'
          optionValueKey='name'
          onChange={(level) => changeValues(level.name, 'learning_days')}
          isSearchable
          error={check('learning_days')}
        />
      </FormField>
    </FormFieldset>
  )
})

export default RequiredFieldsPaidModal
